import { CommonModule, DatePipe } from "@angular/common";
import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { interval, Subscription } from "rxjs";

@Component({
  selector: "app-countdown-timer",
  imports: [CommonModule],
  providers: [DatePipe],
  templateUrl: "./countdown-timer.component.html",
  styleUrl: "./countdown-timer.component.scss",
})
export class CountdownTimerComponent implements OnInit, OnDestroy {
  @Input() cartCreationDate!: string | Date; // Recebe a data de criação do carrinho
  private countdownDuration = 15 * 60 * 1000; // 15 minutos em milissegundos
  timeLeft!: number; // Tempo restante em milissegundos
  formattedTime!: string; // Tempo formatado (ex.: 00:15:00)
  private subscription!: Subscription;
  loading: Boolean = false;

  get expired(): boolean {
    return this.timeLeft <= 0;
  }

  constructor(private datePipe: DatePipe) {}

  ngOnInit(): void {
    this.startCountdown();
  }

  startCountdown() {
    try {
      const cartCreationTime = new Date(this.cartCreationDate).getTime();
      const endTime = cartCreationTime + this.countdownDuration;
      this.subscription = interval(1000).subscribe(() => {
        const currentTime = new Date().getTime();
        this.timeLeft = endTime - currentTime;

        if (this.timeLeft > 0) {
          // Converter tempo restante para formato "mm:ss"
          this.formattedTime = this.formatTime(this.timeLeft);
        } else {
          this.timeLeft = 0;
          this.formattedTime = "00:00";
          this.subscription.unsubscribe(); // Parar o timer quando chegar a 0
        }
      });
    } catch (error) {
      console.log("erro ao iniciar timer", error);
    }
  }

  formatTime(timeInMillis: number): string {
    // Converter milissegundos em minutos e segundos
    const minutes = Math.floor(timeInMillis / (1000 * 60));
    const seconds = Math.floor((timeInMillis % (1000 * 60)) / 1000);

    // Usar o DatePipe para formatar como "mm:ss"
    const date = new Date(0, 0, 0, 0, minutes, seconds); // Criar uma data fictícia
    return this.datePipe.transform(date, "mm:ss") || "00:00";
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
